'use client'

import { createGlobalStyle } from 'styled-components'
import reset from 'styled-reset'

import { typography } from '../../../themes'

export const GlobalStyles = createGlobalStyle`
  ${reset}

  body, html {
    ${typography('body1')}
    line-height: 1;
    letter-spacing: .6px;
    font-family: ${({ theme }) => theme.fontFamily.base};
  }

  *,
  ::before,
  ::after {
    box-sizing: border-box;
    border-style: solid;
    border-width: 0;
  }

  /*
   * フォント指定は要素のみに適用する。疑似要素(::before/::after)に直接
   * font-size 等を当てると、before:content-['※'] のような content 文字が
   * 親要素の font-size(例: text-[10px])を継承できず 16px で描画されてしまう。
   */
  * {
    ${typography('body1')}
    font-family: ${({ theme }) => theme.fontFamily.base};
    line-height: 1;
    letter-spacing: .6px;
  }

  /*
   * 上の styled-reset(Meyer) は div, li, a 等の要素セレクタ(詳細度 0,0,1)で
   * border: 0(= border-style: none)を当てるため、直前の「*」(詳細度 0,0,0)の
   * border リセットが負け、border-style を明示しない border-t / border-b 等の
   * ユーティリティの線が描画されない。同じ詳細度(html *)を後方で宣言して
   * 打ち消し、Tailwind preflight 相当の solid / width 0 を全要素に保証する。
   */
  html *,
  html ::before,
  html ::after {
    border-style: solid;
    border-width: 0;
    /* preflight 相当の default border-color。色クラス無しの border-* が
       currentColor(文字色)で濃く描画されるのを防ぐ(Tailwind 既定 gray-200)。 */
    border-color: #e5e7eb;
  }
`
